export enum CasesListTab {
  ACTIVE = 'active',
  CLOSED = 'closed',
}
